module.exports = __webpack_public_path__ + "img/money.ed086223.png";